<div class="flex justify-center items-center flex-col">
  <div class="text-center text-[15px]">
    <mat-icon *ngIf="isShowIcon" class="!w-5 !h-5 text-[20px] text-red-600 translate-y-1 mr-1">warning</mat-icon>
    <span>{{ text }}</span>
  </div>

  <!-- <mat-icon class="absoute right-2 top-2 cursor-pointer" (click)="close.emit()">close</mat-icon> -->

  <div class="flex justify-center gap-3 mt-3">
    <div igClickStopPropagation
      class="py-1 w-[70px] text-center cursor-pointer rounded border-[deepskyblue] bg-[deepskyblue] text-white border hover:shadow-md"
      matRipple [matRippleCentered]="true" [matRippleColor]="'rgba(255, 255, 255, 0.1)'" (click)="confirm.emit()">
      Yes
    </div>
    <div class="py-1 w-[70px] text-center cursor-pointer rounded border-[lightgray] border hover:shadow-md"
      igClickStopPropagation matRipple [matRippleCentered]="true" [matRippleColor]="'rgba(255, 255, 255, 0.1)'"
      (click)="cancel.emit()">No
    </div>
  </div>
</div>
